// extracted by mini-css-extract-plugin
export var image = "gq_dp";